import CustomHeart from '@public/icons/heart_new.svg';
import React, { SVGProps } from 'react';

type CustomHeartWrapperProps = SVGProps<SVGSVGElement>;
const CustomHeartWrapper: React.FC<CustomHeartWrapperProps> = (props) => {
  return <CustomHeart {...props} />;
};

export default CustomHeartWrapper;
